import React from 'react';
import { WifiOff } from 'lucide-react';

export default function NetworkGuard({ isOnline, children }) {
  if (!isOnline) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '60vh', color: 'var(--text-secondary)',
        textAlign: 'center', padding: 40,
      }}>
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          background: 'var(--error-bg)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 20,
        }}>
          <WifiOff size={36} color="var(--error)" />
        </div>
        <h2 style={{ color: 'var(--text-primary)', marginBottom: 8 }}>No Internet Connection</h2>
        <p style={{ marginBottom: 4 }}>Please check your network connection.</p>
        <p style={{ fontSize: 13, color: 'var(--text-tertiary)' }}>The app will automatically resume when you're back online.</p>
      </div>
    );
  }
  return children;
}